<template>
  <Plain title="Legal">
    <div slot="page_body">
      [text goes here]
    </div>
  </Plain>
</template>
<script>
import Plain from './plain'

export default {
  name: 'Legal',
  components: {
    Plain
  }
}
</script>



// WEBPACK FOOTER //
// src/components/legal.vue